import { Article, ScreenContainer, Button, HeroSection, Hero, HeroHalfContainer, HeroBody, HeroTeaser, HeroActionList, HeroAction, FeatureSection, FeatureList, Feature, FeatureImage, FeatureTitle, FeatureText, SiblingNav, SiblingNavLink } from "smooth-doc/components";
import GettingStarted from "../../../../partials/getting-started.mdx";
import heroBackgroundImageURL from "../../../../images/hero-background.png";
import { RandomLoader } from "../../../../pages/docs/code/loader";
import Title from "../../../../pages/docs/code/title";
import compassImageURL from "../../../../images/internal/compass.svg";
import gameImageURL from "../../../../images/internal/game.svg";
import toolsImageURL from "../../../../images/internal/tools.svg";
import * as React from 'react';
export default {
  Article,
  ScreenContainer,
  Button,
  HeroSection,
  Hero,
  HeroHalfContainer,
  HeroBody,
  HeroTeaser,
  HeroActionList,
  HeroAction,
  FeatureSection,
  FeatureList,
  Feature,
  FeatureImage,
  FeatureTitle,
  FeatureText,
  SiblingNav,
  SiblingNavLink,
  GettingStarted,
  heroBackgroundImageURL,
  RandomLoader,
  Title,
  compassImageURL,
  gameImageURL,
  toolsImageURL,
  React
};